{
    "translation": {
        "errors": {
            "password_requirements": "Passordet ditt må bestå av minst 9 tegn, inkludert et tall, store bokstaver, små bokstaver og et spesialtegn.",
            "password_confirm": "Passordet stemmer ikke overens"
        },

        "generic": {
            "fetching": "Henter data...",
            "submit": "Send",
            "page_not_found": "Siden ble ikke funnet",
            "support": "Støtte",
            "error_title": "Beklager, noe gikk galt.",
            "error_text": "Feilen '{{ errorMessage }}' oppstod. Kontakt støtten for hjelp.",
            "unknown_error_text": "En ukjent feil oppstod. Kontakt støtten for hjelp."
        },

        "email_activation": {
            "title": "E-postaktivering",
            "success_title": "Velkommen til Anio!",
            "success_text": "E-posten ble bekreftet og kontoen er aktivert."
        },

        "password_reset": {
            "title": "Tilbakestill passord",
            "new_password": "Nytt passord",
            "new_password_confirm": "Bekreft nytt passord",
            "success_title": "Passordet ble tilbakestilt!"
        },

        "friend_code": {
            "title": "Legg til venn",
            "description": "Du er invitert til å legge til en venn i Anio-appen.<br />Skriv inn følgende kode i Vennemenyen i Anio-appen:",
            "copy_code": "Kopier kode",
            "code_copied": "Koden ble kopiert til utklippstavlen!"
        }
    }
}
